import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=20cf46bc&scoped=true&"
import script from "./CreditNote.vue?vue&type=script&lang=js&"
export * from "./CreditNote.vue?vue&type=script&lang=js&"
import style0 from "./CreditNote.vue?vue&type=style&index=0&id=20cf46bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf46bc",
  null
  
)

export default component.exports